import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AIAgent } from "@graylog/enterprise-api";
import i18n from "i18n";
import UserNotification from "util/UserNotification";
import { WORKFLOW_DEFINITIONS_QUERY_KEY } from "../Constants";
const useRunWorkflow = ({ onSuccess, type, title }) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: () => AIAgent.run({ type }),
    onSuccess: (run) => {
      UserNotification.success(
        i18n.t("notifications.workflow_run_started", { ns: "enterprise_ai", title }),
        i18n.t("notifications.workflow_run_title", { ns: "enterprise_ai" })
      );
      if (run == null ? void 0 : run.id) {
        queryClient.setQueryData(["aiagent", "workflow-runs", "detail", run.id], run);
      }
      queryClient.invalidateQueries({ queryKey: ["aiagent", "workflow-runs"] });
      onSuccess();
    },
    onError: (error) => {
      if ((error == null ? void 0 : error.status) === 409) {
        UserNotification.warning(
          i18n.t("notifications.workflow_run_in_progress", { ns: "enterprise_ai", title }),
          i18n.t("notifications.workflow_run_title", { ns: "enterprise_ai" })
        );
        queryClient.invalidateQueries({ queryKey: WORKFLOW_DEFINITIONS_QUERY_KEY });
        return;
      }
      UserNotification.error(
        i18n.t("notifications.workflow_run_start_failed", {
          ns: "enterprise_ai",
          message: error instanceof Error ? error.message : String(error)
        }),
        i18n.t("notifications.workflow_run_title", { ns: "enterprise_ai" })
      );
    }
  });
  return { mutate, isPending };
};
export default useRunWorkflow;
